// extracted by mini-css-extract-plugin
module.exports = {"scalable":"ScalableComponent_scalable__XyBU1","content":"ScalableComponent_content__qdN7Q"};